import { styled } from '@mui/material/styles';
import ConfettiExplosion, { ConfettiProps } from 'react-confetti-explosion';

const StyledConfettiExplosion = styled(ConfettiExplosion)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export default StyledConfettiExplosion;
